import React from "react";
import { Router, Location } from "@reach/router";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import Header from "./containers/elements/Header";
import NavLink from "./components/NavLink";
import Historique from "./containers/Historique";
import Technique from "./containers/Technique";
import Logitheque from "./containers/Logitheque";
import Programmation from "./containers/Programmation";
import Lesson from "./containers/Lesson";
import Sheet from "./containers/Sheet";

import {translate} from './containers/i18n';
import { defaultLang } from './components/common/Constants';
import {I18nContext } from './containers/i18n/I18nProvider';


import "./styles/app.css";

class App extends React.Component {

  static contextType = I18nContext;

  constructor(props) {
    super(props );

    this.updateLang = this.updateLang.bind(this);
    this.getMenu = this.getMenu.bind(this);

    this.getMenu();
  }

  componentDidUpdate(prevProps) {
    if (this.context.lang !== prevProps.lang) this.getMenu();
  }

  getMenu() {
    console.log("GET MENU !");
    const t = this.props.t;

    this.menu = [
      {
        label: t("menu1"),
        path: "page/historique"
      },
      {
        label: t("menu2"),
        path: "page/technique",
        id: "technique",
        subMenu: [
          { label: t("menu2item1"), path: "sheet/tq1" },
          { label: t("menu2item2"), path: "sheet/tq2" },
          { label: t("menu2item3"), path: "sheet/tq3" },
          { label: t("menu2item5"), path: "sheet/tq5" },
          { label: t("menu2item7"), path: "sheet/tq7" }
        ]
      },
      {
        label: t("menu3"),
        path: "page/logitheque",
        id: "logitheque",
        subMenu: [
          { pyuta : [
            { id:1, label: t("menu3item1"), path: "game/g1", col: "#000", bcol: "#b32f48" },
            { id:2, label: t("menu3item2"), path: "game/g2", col: "#000", bcol: "#4f6da0"  },
            { id:3, label: t("menu3item3"), path: "game/g3", col: "#000", bcol: "#88a75b"  },
            { id:4, label: t("menu3item4"), path: "game/g4", col: "#000", bcol: "#c05a73"  },
            { id:5, label: t("menu3item5"), path: "game/g5", col: "#000", bcol: "#c89441"  },
            { id:6, label: t("menu3item6"), path: "game/g6", col: "#000", bcol: "#dabc4d"  },
            { id:7, label: t("menu3item7"), path: "game/g7", col: "#fff", bcol: "#f08c92"  },
            { id:8, label: t("menu3item8"), path: "game/g8", col: "#fff", bcol: "#4f838b"  },
            { id:9, label: t("menu3item9"), path: "game/g9", col: "#e4b54b", bcol: "#b3818a"  },
            { id:10, label: t("menu3item10"), path: "game/g10", col: "#4f838b", bcol: "#f5e775"  },
            { id:11, label: t("menu3item11"), path: "game/g11", col: "#fff", bcol: "#ebba36" },
            { id:12, label: t("menu3item12"), path: "game/g12", col: "#4f838b", bcol: "#e4b54b" },
            { id:13, label: t("menu3item13"), path: "game/g13", col: "#4f838b", bcol: "#e4b54b"  },
            { id:14, label: t("menu3item14"), path: "game/g14", col: "#4f838b", bcol: "#e4b54b"  },
            { id:15, label: t("menu3item15"), path: "game/g15", col: "#4f838b", bcol: "#e4b54b"  },
            { id:16, label: t("menu3item16"), path: "game/g16", col: "#4f838b", bcol: "#e4b54b"  },
            { id:17, label: t("menu3item17"), path: "game/g17", col: "#4f838b", bcol: "#e4b54b"  },
            { id:18, label: t("menu3item18"), path: "game/g18", col: "#4f838b", bcol: "#e4b54b"  },
            { id:19, label: t("menu3item19"), path: "game/g19", col: "#4f838b", bcol: "#e4b54b"  },
            { id:20, label: t("menu3item20"), path: "game/g20", col: "#4f838b", bcol: "#e4b54b"  },
            { id:21, label: t("menu3item21"), path: "game/g21", col: "#4f838b", bcol: "#e4b54b"  },
            { id:22, label: t("menu3item22"), path: "game/g22", col: "#4f838b", bcol: "#e4b54b"  },
            { id:23, label: t("menu3item23"), path: "game/g23", col: "#4f838b", bcol: "#e4b54b"  },
            { id:24, label: t("menu3item24"), path: "game/g24", col: "#4f838b", bcol: "#e4b54b"  },
            { id:25, label: t("menu3item25"), path: "game/g25", col: "#4f838b", bcol: "#e4b54b"  },
            { id:26, label: t("menu3item26"), path: "game/g26", col: "#4f838b", bcol: "#e4b54b"  }
          ]},
          { tutor : [
            { id:1, label: t("menu3item1b"), path: "game/g1"},
            { id:2, label: t("menu3item2b"), path: "game/g1" },
            { id:3, label: t("menu3item3b"), path: "game/g1" },
            { id:4, label: t("menu3item4b"), path: "game/g1" },
            { id:5, label: t("menu3item5b"), path: "game/g1" },
            { id:6, label: t("menu3item6b"), path: "game/g1" },
            { id:7, label: t("menu3item7b"), path: "game/g1" },
            { id:8, label: t("menu3item8b"), path: "game/g1" },
            { id:9, label: t("menu3item9b"), path: "game/g1" },
            { id:10, label: t("menu3item10b"), path: "game/g1" },
          ]} 
        ]
      },
      {
        label: t("menu4"),
        path: "page/programmation",
        id: "programmation",
        subMenu: [
          { label: t("menu4item1"), path: "lesson/tc1" },
          { label: t("menu4item2"), path: "lesson/tc2" },
          { label: t("menu4item3"), path: "lesson/tc3" },
          { label: t("menu4item4"), path: "lesson/tc4" },
          { label: t("menu4item5"), path: "lesson/tc5" },
          { label: t("menu4item6"), path: "lesson/tc6" },
          { label: t("menu4item7"), path: "lesson/tc7" },
          { label: t("menu4item8"), path: "lesson/tc8" },
          { label: t("menu4item9"), path: "lesson/tc9" },
          { label: t("menu4item10"), path: "lesson/tc10" },
          { label: t("menu4item11"), path: "lesson/tc11" },
          { label: t("menu4item12"), path: "lesson/tc12" }
        ]
      }
    ];

    console.log(this.context, "menu ?", this.menu);
  }
  
  updateLang(lang) {
    this.context.setLangFlag(lang);
  }

  render() {
    this.lang = this.context.lang || defaultLang;

    return (
      <div className="app">
        <Header lang={this.lang} updateLang={this.updateLang}/>
        <Nav menu={this.menu}/>

        <FadeTransitionRouter>
          <Page path="/" page="historique" />
          <Page path="page/technique" page="technique" menu={this.menu} lang={this.lang}>
            <Sheet path="/" />
            <Sheet path="sheet/:sheetId" />
          </Page>         
          <Page path="page/programmation" page="programmation" menu={this.menu} lang={this.lang}>
            <Lesson path="/" />
            <Lesson path="lesson/:lessonId" />
          </Page>
          <Page path="page/:page" menu={this.menu} lang={this.lang}/>
        </FadeTransitionRouter>
      </div>
    );
  }
}

const FadeTransitionRouter = props => (
  <Location>
    {({ location }) => (
      <TransitionGroup className="transition-group">
        <CSSTransition key={location.key} classNames="fade" timeout={500}>
          <Router location={location} className="router">
            {props.children}
          </Router>
        </CSSTransition>
      </TransitionGroup>
    )}
  </Location>
);

const Nav = (props, lang) => {
  const menu = props.menu;
  return (
    <nav className="nav">
      {menu.map(item => {
        return (
          <div key={item.label}>
            <NavLink to={item.path}>{item.label}</NavLink>
          </div>
        );
      })}
    </nav>
  );
};

const Page = props => {
  const bgColor = props.background || "#ffffff";
  const content = getContentPage(
    props.page,
    props.menu,
    props.lang
  );
  return (
    <div className="page" style={{ background: `${bgColor}` }}>
      {content}
    </div>
  );
};

const getContentPage = (id, menuAll, lang) => {
  const menu = menuAll ? menuAll.find(item => item.id === id) : [];
  lang = lang || defaultLang;

  switch (id) {
    case "historique":
      return <Historique url={lang + "/historique"}/>;
    case "technique":
      return <Technique menu={menu} url={lang + "/technique"}/>;
    case "logitheque":
      return <Logitheque menu={menu} url={lang+"/logitheque"}/>;
    case "programmation":
      return <Programmation menu={menu} url={lang + "/programmation"}/>;
    default:
      return <Historique url={lang + "/historique"}/>;
  }
};

export default translate(App);
